import { checkDate } from "common/helpers/Date";
import { ITaskContextData, TaskContextRecord, taskContextFromJSON } from "common/records/TaskContext";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from ".";

export const taskFromJSON = (json: Partial<ITaskData>): TaskRecord => {
  const data: ITaskRecord = { ...(json as any) };

  if (json.context) {
    data.context = taskContextFromJSON(json.context);
  }

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    data.updated_at = checkDate(json.updated_at);
  }

  return new TaskRecord(data);
};

export type TaskStatus = "submitted" | "processing" | "error" | "finished";

export interface ITaskData {
  id: string;
  job_id: Nullable<string>;
  lock_version: Nullable<number>;
  logs: string;
  location: string;
  results: any;
  status: TaskStatus;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  context: Nullable<ITaskContextData>;
}

export interface ITaskRecord {
  id: string;
  job_id: Nullable<string>;
  lock_version: Nullable<number>;
  logs: string;
  location: string;
  results: any;
  status: TaskStatus;
  created_at: Date;
  updated_at: Date;
  context: Nullable<TaskContextRecord>;
}

const defaultTaskProps = {
  id: "",
  job_id: null,
  lock_version: null,
  logs: "",
  location: "",
  results: {},
  status: "submitted" as TaskStatus,
  created_at: new Date(),
  updated_at: new Date(),
  context: null,
};

export class TaskRecord extends Record<ITaskRecord>(defaultTaskProps) implements ITaskRecord {}
